import React from 'react'
import { Course } from '../../Course/types'
import { Collapse, Typography } from 'antd'
import { FlexColumn, FlexRow } from '../../FlexboxReusables/FlexItems'
import dayjs from 'dayjs'
import { FormattedMessage, useIntl } from 'react-intl'
import { dateFormat } from '../../../globals'

type ReviewSummaryProps = {
  course: Course | undefined
  startDate: dayjs.Dayjs
  endDate?: dayjs.Dayjs | null
  examDuration: number
}

const ReviewSummary: React.FC<ReviewSummaryProps> = (props: ReviewSummaryProps) => {
  const { course, startDate, examDuration } = props

  const intl = useIntl()

  const formattedStartDate = startDate.format(dateFormat)

  return (
    <>
      <FlexRow margin='1em 0 0 0'>
        <Typography.Title level={4}>
          {course?.name}
        </Typography.Title>
      </FlexRow>
      <FlexRow margin='0 0 1em 0'>
        <Typography.Text>{course?.description}</Typography.Text>
      </FlexRow>

      <FlexRow margin='1em 0'>
        <Collapse defaultActiveKey={2} style={{width: '80%'}}>
          <Collapse.Panel header={intl.formatMessage({id: 'generic.questionsAndAnswers'})} key='2'>
            {course?.questions.map((question, questionIndex) => (
              <FlexColumn
                key={questionIndex}
                margin='2em 0'
                alignItems='flex-start'
              >
                <Typography.Title level={5}>
                  {`${intl.formatMessage({id: 'generic.question'})} ${questionIndex + 1}: ${question.text}`}
                </Typography.Title>
                {question.answers.map((answer, answerIndex) => (
                  <FlexRow key={answerIndex} justifyContent='flex-start'>
                    <Typography.Text
                      style={{
                        color: answer.isCorrect ? 'green' : 'red',
                        fontWeight: answer.isCorrect ? 'bold' : 'lighter',
                      }}
                    >
                      {`${intl.formatMessage({id: 'generic.answer'})} ${answerIndex + 1}: ${answer.text}`}
                    </Typography.Text>
                  </FlexRow>
                ))}
              </FlexColumn>
            ))}
          </Collapse.Panel>
        </Collapse>
      </FlexRow>

      <FlexRow margin='1em 0'>
        <Collapse defaultActiveKey={3} style={{width: '80%'}}>
          <Collapse.Panel header={intl.formatMessage({id: 'generic.exam'})} key='3'>
            {startDate && (
              <>
                <FlexRow margin='1em 0'>
                  <FlexColumn alignItems='flex-start'>
                    <Typography.Text strong>
                      <FormattedMessage id='exam.examStartsAt' />
                    </Typography.Text>
                    <Typography.Text>{formattedStartDate}</Typography.Text>
                  </FlexColumn>
                </FlexRow>
                <FlexRow justifyContent='flex-start' margin='1em 0'>
                  <Typography.Text strong>
                    <FormattedMessage id='generic.duration' />:
                  </Typography.Text>
                  <Typography.Text>
                    {examDuration} <FormattedMessage id='generic.minutes'/>
                  </Typography.Text>
                </FlexRow>
                <FlexRow justifyContent='flex-start' margin='1em 0'>
                  <Typography.Text strong>
                    <FormattedMessage id='editor.questions.minimumTargetAchievement' />: 
                  </Typography.Text>
                  <Typography.Text>{course?.minPercentageToPass} Prozent</Typography.Text>
                </FlexRow>
                <FlexRow justifyContent='flex-start' margin='1em 0'>
                  <Typography.Text strong>
                    <FormattedMessage id='editor.questions.totalPoints' />: 
                  </Typography.Text>
                  <Typography.Text>
                    {course?.totalPoints} <FormattedMessage id='generic.points' />
                  </Typography.Text>
                </FlexRow>
              </>
            )}
          </Collapse.Panel>
        </Collapse>
      </FlexRow>
    </>
  )
}

export default ReviewSummary